import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';

import { StackedHeader } from 'components/DataDisplay';
import { ChartMixedIcon } from 'components/Icons';
import { Drawer } from 'components/Overlay';
import { CDashboard } from 'components/Visualization';
import { useUserDashboard } from 'containers/Findings/FindingsOverview/hooks/useUserDashboard';

interface IAggregatedAlertDrawer {
  isOpen: boolean;
  onClose();
  title: string;
}

export const AggregateAlertSummary: FC<IAggregatedAlertDrawer> = props => {
  const { isOpen, onClose, title } = props;
  const { alertSummaryWidgets } = useUserDashboard();

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      header={
        <StackedHeader
          upper="Alert Summary"
          lower={title}
          icon={<ChartMixedIcon />}
        />
      }
      body={
        <Box h="full" w="full" pt={3}>
          <CDashboard dashboardWidgets={alertSummaryWidgets} />
        </Box>
      }
      closeButton
      styles={{
        content: { maxW: '4xl' },
        drawer: {
          portalProps: {},
          blockScrollOnMount: false,
        },
      }}
    />
  );
};
